import Vue from 'vue'
import App from './App.vue'
import Axios from 'axios'
import router from './router/index'
import { Button, Pagination, Dialog, Tabs } from 'element-ui'
import { showLoading, hideLoading } from './utils/loading';

Vue.prototype.$http = Axios
Vue.config.productionTip = false

Vue.prototype.$ELEMENT = { size: 'normal', zIndex: 3000 };
Vue.use(Pagination);
Vue.use(Button);
Vue.use(Dialog);
Vue.use(Tabs)

Vue.prototype.$showLoading = showLoading
Vue.prototype.$hideLoading = hideLoading

new Vue({
    router,
    render: h => h(App)
}).$mount('#app')

// 过滤器
Vue.filter('formatDate', function (str) {
      if (!str) return ''
      var date = new Date(str)
      var time = new Date().getTime() - date.getTime() //现在的时间-传入的时间 = 相差的时间（单位 = 毫秒）
      if (time < 0) {
        return ''
      } else if ((time / 1000 < 30)) {
        return '刚刚'
      } else if (time / 1000 < 60) {
        return parseInt((time / 1000)) + ' 秒前'
      } else if ((time / 60000) < 60) {
        return parseInt((time / 60000)) + ' 分钟前'
      } else if ((time / 3600000) < 24) {
        return parseInt(time / 3600000) + ' 小时前'
      } else if ((time / 86400000) < 31) {
        return parseInt(time / 86400000) + ' 天前'
      } else if ((time / 2592000000) < 12) {
        return parseInt(time / 2592000000) + ' 个月前'
      } else {
        return parseInt(time / 31536000000) + ' 年前'
      }
    }
)

Vue.filter('tabFormatter',function (post) {
  if(post.good == true){
    return '精华'
  }else if(post.top == true){
    return '置顶'
  }else if(post.tab == 'ask'){
    return '问答'
  }else if(post.tab == 'share'){
    return '分享'
  }else{
    return '招聘'
  }
})
